/* HOLIGRAM PREMIUM — Scroll Reveal & Micro-interactions */
document.addEventListener('DOMContentLoaded', function() {

  /* --- Login form: add logo + subtitle --- */
  var loginForm = document.querySelector('.customer.login h1#login');
  if (loginForm) {
    var iconSvgLogin = '<svg class="hprem-login-logo" viewBox="0 0 300 300"><circle fill="currentColor" cx="150" cy="257.1" r="8.28"/><path fill="currentColor" d="M258.09,127.88c.02,1.64-.13,3.37-.5,5.18-.63,3.05-1.78,5.65-3.12,7.83-4.49,7.52-12.71,12.56-22.11,12.56-.2,0-.4-.01-.6-.02-2,.1-4.03,.14-6.12,.23-20.81,.93-50.5,8.22-54.17,22.22-.03,.1-.06,.23-.1,.38-.07,.63-.16,1.26-.28,1.87-.09,1.2-.02,2.73,.54,4.32,3.74,10.66,25.32,12.86,28.23,13.15,6.38,.65,9.87,0,15.5,2.5,2.32,1.03,6.38,2.91,9.52,7.27l.07,.09c1.14,1.49,2.05,3.17,2.67,4.98,.93,2.51,1.54,5.74,.78,9.37-.54,2.55-1.66,4.83-3.16,6.77-3.22,4.46-8.46,7.37-14.38,7.37-3.46,0-6.69-1-9.41-2.71-4.93-2.84-7.26-7.59-12.67-15.35-7.89-11.32-17.39-24.95-25.92-23.48-2.11,.36-3.6,1.62-4.47,2.34-5.59,4.69-5.24,13.39-5.09,17.07,.23,5.54,1.79,13.04,2.29,20.28,.06,.8,.16,2.69-.98,4.34-.86,1.24-2.5,2.45-4.61,2.45-2.11,0-3.75-1.21-4.61-2.45-1.14-1.65-1.04-3.54-.98-4.34,.5-7.24,2.06-14.73,2.29-20.28,.15-3.68,.51-12.38-5.09-17.07-.87-.73-2.36-1.98-4.47-2.34-8.53-1.47-18.03,12.15-25.92,23.48-5.41,7.76-7.74,12.51-12.67,15.35-2.73,1.71-5.95,2.71-9.41,2.71-5.92,0-11.16-2.91-14.38-7.37-1.5-1.94-2.62-4.21-3.16-6.77-.76-3.62-.15-6.86,.78-9.37,.62-1.81,1.53-3.49,2.67-4.98l.07-.09c3.14-4.36,7.21-6.25,9.52-7.27,5.64-2.5,9.12-1.86,15.5-2.5,2.91-.3,24.49-2.49,28.23-13.15,.56-1.59,.63-3.12,.54-4.32-.12-.62-.22-1.24-.28-1.87-.04-.16-.07-.28-.1-.38-3.68-14-33.36-21.29-54.17-22.22-2.09-.09-4.12-.12-6.12-.23-.2,0-.4,.02-.6,.02-9.4,0-17.62-5.04-22.11-12.56-1.34-2.18-2.49-4.78-3.12-7.83-.38-1.81-.52-3.54-.5-5.18,0-.06,0-.11,0-.17,0-13.83,10.91-25.12,24.6-25.72,.31-.02,.62-.04,.93-.05,9.26-.26,15.67,4.66,17.48,6.09,6.72,5.33,6.74,10.39,11.71,19.41,9.35,16.98,27.22,31.69,39.06,28.81,2.26-.55,3.77-1.7,4.14-1.98,7.64-5.75,5.08-26.03,5.08-26.03-1.99-15.88-4.26-34.06-14.92-54.85-2.05-4-5.45-10.12-4.49-17.8,1.15-9.24,7.9-15.03,8.34-15.4,.08-.07,.19-.16,.32-.26,.75-.6,4.18-3.28,9.45-4.63,5.94-1.52,10.91-.48,12.79,0,5.26,1.34,8.7,4.03,9.45,4.63,.13,.11,.24,.19,.32,.26,.44,.37,7.19,6.15,8.34,15.4,.96,7.68-2.44,13.8-4.49,17.8-10.65,20.79-12.93,38.98-14.92,54.85,0,0-2.56,20.29,5.08,26.03,.37,.28,1.88,1.43,4.14,1.98,11.84,2.88,29.71-11.83,39.06-28.81,4.97-9.02,4.99-14.08,11.71-19.41,1.81-1.44,8.23-6.36,17.48-6.09,.31,0,.62,.03,.93,.05,13.69,.6,24.6,11.88,24.6,25.72,0,.06,0,.11,0,.17Z"/></svg>';
    loginForm.insertAdjacentHTML('beforebegin', iconSvgLogin);
    var sub = document.createElement('p');
    sub.className = 'hprem-login-sub';
    sub.textContent = 'Welkom bij Holigram B2B Wholesale';
    loginForm.insertAdjacentElement('afterend', sub);
    /* Add divider at the end */
    var container = loginForm.closest('.customer.login');
    if (container) {
      var hr = document.createElement('hr');
      hr.className = 'hprem-login-divider';
      container.appendChild(hr);
    }
  }

  /* --- Homepage login page: remove trailing dot + add floating icons --- */
  if (document.body.classList.contains('template-index')) {
    var loginP = document.querySelector('#MainContent > p');
    if (loginP && loginP.textContent.indexOf('account nodig') !== -1) {
      /* Remove the trailing "." after the link */
      var nodes = loginP.childNodes;
      for (var n = nodes.length - 1; n >= 0; n--) {
        if (nodes[n].nodeType === 3 && nodes[n].textContent.trim() === '.') {
          nodes[n].textContent = '';
          break;
        }
      }
      /* Add floating Holigram icons to background */
      var main = document.getElementById('MainContent');
      if (main) {
        var iconSvg = '<svg viewBox="0 0 300 300"><circle fill="currentColor" cx="150" cy="257.1" r="8.28"/><path fill="currentColor" d="M258.09,127.88c.02,1.64-.13,3.37-.5,5.18-.63,3.05-1.78,5.65-3.12,7.83-4.49,7.52-12.71,12.56-22.11,12.56-.2,0-.4-.01-.6-.02-2,.1-4.03,.14-6.12,.23-20.81,.93-50.5,8.22-54.17,22.22-.03,.1-.06,.23-.1,.38-.07,.63-.16,1.26-.28,1.87-.09,1.2-.02,2.73,.54,4.32,3.74,10.66,25.32,12.86,28.23,13.15,6.38,.65,9.87,0,15.5,2.5,2.32,1.03,6.38,2.91,9.52,7.27l.07,.09c1.14,1.49,2.05,3.17,2.67,4.98,.93,2.51,1.54,5.74,.78,9.37-.54,2.55-1.66,4.83-3.16,6.77-3.22,4.46-8.46,7.37-14.38,7.37-3.46,0-6.69-1-9.41-2.71-4.93-2.84-7.26-7.59-12.67-15.35-7.89-11.32-17.39-24.95-25.92-23.48-2.11,.36-3.6,1.62-4.47,2.34-5.59,4.69-5.24,13.39-5.09,17.07,.23,5.54,1.79,13.04,2.29,20.28,.06,.8,.16,2.69-.98,4.34-.86,1.24-2.5,2.45-4.61,2.45-2.11,0-3.75-1.21-4.61-2.45-1.14-1.65-1.04-3.54-.98-4.34,.5-7.24,2.06-14.73,2.29-20.28,.15-3.68,.51-12.38-5.09-17.07-.87-.73-2.36-1.98-4.47-2.34-8.53-1.47-18.03,12.15-25.92,23.48-5.41,7.76-7.74,12.51-12.67,15.35-2.73,1.71-5.95,2.71-9.41,2.71-5.92,0-11.16-2.91-14.38-7.37-1.5-1.94-2.62-4.21-3.16-6.77-.76-3.62-.15-6.86,.78-9.37,.62-1.81,1.53-3.49,2.67-4.98l.07-.09c3.14-4.36,7.21-6.25,9.52-7.27,5.64-2.5,9.12-1.86,15.5-2.5,2.91-.3,24.49-2.49,28.23-13.15,.56-1.59,.63-3.12,.54-4.32-.12-.62-.22-1.24-.28-1.87-.04-.16-.07-.28-.1-.38-3.68-14-33.36-21.29-54.17-22.22-2.09-.09-4.12-.12-6.12-.23-.2,0-.4,.02-.6,.02-9.4,0-17.62-5.04-22.11-12.56-1.34-2.18-2.49-4.78-3.12-7.83-.38-1.81-.52-3.54-.5-5.18,0-.06,0-.11,0-.17,0-13.83,10.91-25.12,24.6-25.72,.31-.02,.62-.04,.93-.05,9.26-.26,15.67,4.66,17.48,6.09,6.72,5.33,6.74,10.39,11.71,19.41,9.35,16.98,27.22,31.69,39.06,28.81,2.26-.55,3.77-1.7,4.14-1.98,7.64-5.75,5.08-26.03,5.08-26.03-1.99-15.88-4.26-34.06-14.92-54.85-2.05-4-5.45-10.12-4.49-17.8,1.15-9.24,7.9-15.03,8.34-15.4,.08-.07,.19-.16,.32-.26,.75-.6,4.18-3.28,9.45-4.63,5.94-1.52,10.91-.48,12.79,0,5.26,1.34,8.7,4.03,9.45,4.63,.13,.11,.24,.19,.32,.26,.44,.37,7.19,6.15,8.34,15.4,.96,7.68-2.44,13.8-4.49,17.8-10.65,20.79-12.93,38.98-14.92,54.85,0,0-2.56,20.29,5.08,26.03,.37,.28,1.88,1.43,4.14,1.98,11.84,2.88,29.71-11.83,39.06-28.81,4.97-9.02,4.99-14.08,11.71-19.41,1.81-1.44,8.23-6.36,17.48-6.09,.31,0,.62,.03,.93,.05,13.69,.6,24.6,11.88,24.6,25.72,0,.06,0,.11,0,.17Z"/></svg>';
        var icons = [
          { x: '8%',  y: '15%', size: 140, rot: 15,  color: '#BE541C', delay: 0 },
          { x: '85%', y: '20%', size: 100, rot: -20, color: '#478367', delay: 1.5 },
          { x: '12%', y: '70%', size: 80,  rot: 30,  color: '#478367', delay: 3 },
          { x: '80%', y: '65%', size: 120, rot: -10, color: '#BE541C', delay: 0.8 },
          { x: '50%', y: '85%', size: 60,  rot: 45,  color: '#2D4A35', delay: 2.2 },
        ];
        var container = document.createElement('div');
        container.className = 'hprem-login-icons';
        container.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < icons.length; i++) {
          var ic = icons[i];
          var el = document.createElement('div');
          el.className = 'hprem-login-icon';
          el.style.cssText = 'left:' + ic.x + ';top:' + ic.y + ';width:' + ic.size + 'px;height:' + ic.size + 'px;color:' + ic.color + ';transform:rotate(' + ic.rot + 'deg);animation-delay:' + ic.delay + 's';
          el.innerHTML = iconSvg;
          container.appendChild(el);
        }
        main.insertBefore(container, main.firstChild);
      }
    }
  }

  /* --- Scroll reveal for grid items --- */
  var items = document.querySelectorAll('.grid__item');
  if (items.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hprem-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function(el, i) {
      el.style.setProperty('--cascade', i % 12);
      el.classList.add('hprem-ready');
      observer.observe(el);
    });
  }

  /* --- Cart bubble pop animation on count change --- */
  var bubble = document.querySelector('.cart-count-bubble');
  if (bubble) {
    var mo = new MutationObserver(function() {
      bubble.classList.remove('hprem-pop');
      void bubble.offsetWidth;
      bubble.classList.add('hprem-pop');
    });
    mo.observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  /* --- Dark mode: remove facet borders via direct style --- */
  if (document.documentElement.classList.contains('hprem-dark')) {
    var fc = document.getElementById('main-collection-filters');
    if (fc) {
      [fc].concat(Array.from(fc.querySelectorAll('details, summary, form, div, fieldset, ul, aside'))).forEach(function(el) {
        el.style.cssText += ';border:none!important;outline:none!important;box-shadow:none!important;';
      });
    }
  }

  /* --- Dark mode: restore from localStorage --- */
  if (localStorage.getItem('holigram-dark-mode') === 'on') {
    document.documentElement.classList.add('hprem-dark');
  }
  /* Re-apply on tab focus (handles bfcache / Shopify preview reloads) */
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden && localStorage.getItem('holigram-dark-mode') === 'on') {
      document.documentElement.classList.add('hprem-dark');
    }
  });
  window.addEventListener('pageshow', function() {
    if (localStorage.getItem('holigram-dark-mode') === 'on') {
      document.documentElement.classList.add('hprem-dark');
    }
  });

  /* --- Dark mode toggle (in header) --- */
  var moonSvg = '<svg class="hprem-icon-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';
  var sunSvg = '<svg class="hprem-icon-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>';
  var darkBtn = document.createElement('button');
  darkBtn.className = 'hprem-dark-toggle';
  darkBtn.setAttribute('aria-label', 'Donkere modus');
  darkBtn.innerHTML = moonSvg + sunSvg;
  var headerIcons = document.querySelector('.header__icons');
  if (headerIcons) {
    /* Insert BEFORE search icon (left of search) */
    var searchIcon = headerIcons.querySelector('.header__search');
    if (searchIcon) {
      headerIcons.insertBefore(darkBtn, searchIcon);
    } else {
      /* Fallback: insert as first child */
      headerIcons.insertBefore(darkBtn, headerIcons.firstChild);
    }
  }

  /* Shared toggle function (used by header btn + drawer btn) */
  function hpremToggleDark() {
    document.documentElement.classList.add('hprem-dark-transition');
    document.documentElement.classList.toggle('hprem-dark');
    var isDark = document.documentElement.classList.contains('hprem-dark');
    localStorage.setItem('holigram-dark-mode', isDark ? 'on' : 'off');
    /* Lazy-load dark CSS on first activation (cached after) */
    if (isDark && !document.getElementById('holigram-premium-dark-css')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.id = 'holigram-premium-dark-css';
      l.href = window.holigramPremiumDarkCssUrl;
      document.head.appendChild(l);
    }
    setTimeout(function() {
      document.documentElement.classList.remove('hprem-dark-transition');
    }, 350);
  }

  darkBtn.addEventListener('click', hpremToggleDark);

  /* --- Premium mobile menu drawer enhancements --- */
  var drawerNav = document.querySelector('.menu-drawer__navigation');
  var drawerUtility = document.querySelector('.menu-drawer__utility-links');

  /* Staffelkorting info card — after menu items */
  if (drawerNav) {
    var infoCard = document.createElement('div');
    infoCard.className = 'hprem-drawer-info';
    infoCard.innerHTML =
      '<div class="hprem-drawer-info__title">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
        'Staffelkorting bloemen' +
      '</div>' +
      '<div class="hprem-drawer-info__tiers">' +
        '<div class="hprem-drawer-info__tier"><strong>2%</strong>vanaf<br><span>1 kg</span></div>' +
        '<div class="hprem-drawer-info__tier"><strong>5%</strong>vanaf<br><span>2 kg</span></div>' +
        '<div class="hprem-drawer-info__tier"><strong>10%</strong>vanaf<br><span>4 kg</span></div>' +
      '</div>';
    drawerNav.insertAdjacentElement('afterend', infoCard);
  }

  /* Dark mode toggle — pill switch */
  if (drawerUtility) {
    var darkRow = document.createElement('button');
    darkRow.className = 'hprem-drawer-dark';
    darkRow.setAttribute('aria-label', 'Donkere modus');
    darkRow.innerHTML =
      '<span class="hprem-drawer-dark__label">' +
        moonSvg + sunSvg +
        'Donkere modus' +
      '</span>' +
      '<span class="hprem-drawer-dark__track"></span>';
    drawerUtility.insertBefore(darkRow, drawerUtility.firstChild);
    darkRow.addEventListener('click', hpremToggleDark);

    /* Brand footer */
    var brandLine = document.createElement('div');
    brandLine.className = 'hprem-drawer-brand';
    brandLine.textContent = 'Holigram \u00B7 B2B Wholesale';
    drawerUtility.appendChild(brandLine);
  }

  /* --- Page loader + smooth transitions --- */
  var loaderSvg = '<svg viewBox="0 0 300 300"><circle fill="currentColor" cx="150" cy="257.1" r="8.28"/><path fill="currentColor" d="M258.09,127.88c.02,1.64-.13,3.37-.5,5.18-.63,3.05-1.78,5.65-3.12,7.83-4.49,7.52-12.71,12.56-22.11,12.56-.2,0-.4-.01-.6-.02-2,.1-4.03,.14-6.12,.23-20.81,.93-50.5,8.22-54.17,22.22-.03,.1-.06,.23-.1,.38-.07,.63-.16,1.26-.28,1.87-.09,1.2-.02,2.73,.54,4.32,3.74,10.66,25.32,12.86,28.23,13.15,6.38,.65,9.87,0,15.5,2.5,2.32,1.03,6.38,2.91,9.52,7.27l.07,.09c1.14,1.49,2.05,3.17,2.67,4.98,.93,2.51,1.54,5.74,.78,9.37-.54,2.55-1.66,4.83-3.16,6.77-3.22,4.46-8.46,7.37-14.38,7.37-3.46,0-6.69-1-9.41-2.71-4.93-2.84-7.26-7.59-12.67-15.35-7.89-11.32-17.39-24.95-25.92-23.48-2.11,.36-3.6,1.62-4.47,2.34-5.59,4.69-5.24,13.39-5.09,17.07,.23,5.54,1.79,13.04,2.29,20.28,.06,.8,.16,2.69-.98,4.34-.86,1.24-2.5,2.45-4.61,2.45-2.11,0-3.75-1.21-4.61-2.45-1.14-1.65-1.04-3.54-.98-4.34,.5-7.24,2.06-14.73,2.29-20.28,.15-3.68,.51-12.38-5.09-17.07-.87-.73-2.36-1.98-4.47-2.34-8.53-1.47-18.03,12.15-25.92,23.48-5.41,7.76-7.74,12.51-12.67,15.35-2.73,1.71-5.95,2.71-9.41,2.71-5.92,0-11.16-2.91-14.38-7.37-1.5-1.94-2.62-4.21-3.16-6.77-.76-3.62-.15-6.86,.78-9.37,.62-1.81,1.53-3.49,2.67-4.98l.07-.09c3.14-4.36,7.21-6.25,9.52-7.27,5.64-2.5,9.12-1.86,15.5-2.5,2.91-.3,24.49-2.49,28.23-13.15,.56-1.59,.63-3.12,.54-4.32-.12-.62-.22-1.24-.28-1.87-.04-.16-.07-.28-.1-.38-3.68-14-33.36-21.29-54.17-22.22-2.09-.09-4.12-.12-6.12-.23-.2,0-.4,.02-.6,.02-9.4,0-17.62-5.04-22.11-12.56-1.34-2.18-2.49-4.78-3.12-7.83-.38-1.81-.52-3.54-.5-5.18,0-.06,0-.11,0-.17,0-13.83,10.91-25.12,24.6-25.72,.31-.02,.62-.04,.93-.05,9.26-.26,15.67,4.66,17.48,6.09,6.72,5.33,6.74,10.39,11.71,19.41,9.35,16.98,27.22,31.69,39.06,28.81,2.26-.55,3.77-1.7,4.14-1.98,7.64-5.75,5.08-26.03,5.08-26.03-1.99-15.88-4.26-34.06-14.92-54.85-2.05-4-5.45-10.12-4.49-17.8,1.15-9.24,7.9-15.03,8.34-15.4,.08-.07,.19-.16,.32-.26,.75-.6,4.18-3.28,9.45-4.63,5.94-1.52,10.91-.48,12.79,0,5.26,1.34,8.7,4.03,9.45,4.63,.13,.11,.24,.19,.32,.26,.44,.37,7.19,6.15,8.34,15.4,.96,7.68-2.44,13.8-4.49,17.8-10.65,20.79-12.93,38.98-14.92,54.85,0,0-2.56,20.29,5.08,26.03,.37,.28,1.88,1.43,4.14,1.98,11.84,2.88,29.71-11.83,39.06-28.81,4.97-9.02,4.99-14.08,11.71-19.41,1.81-1.44,8.23-6.36,17.48-6.09,.31,0,.62,.03,.93,.05,13.69,.6,24.6,11.88,24.6,25.72,0,.06,0,.11,0,.17Z"/></svg>';

  /* Create loader element */
  var loader = document.createElement('div');
  loader.className = 'hprem-loader hprem-loader--hidden';
  loader.innerHTML = '<div class="hprem-loader__icon">' + loaderSvg + '</div><div class="hprem-loader__bar"></div>';
  document.body.appendChild(loader);

  /* Fade in page on load */
  document.body.classList.add('hprem-enter');

  /* Intercept internal link clicks */
  document.addEventListener('click', function(e) {
    /* Allow modifier-clicks and middle-mouse to behave natively (new tab/window) */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    var link = e.target.closest('a');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('javascript') || href.startsWith('mailto') || href.startsWith('tel:') || href.startsWith('sms:') || link.target === '_blank') return;
    if (link.hasAttribute('download')) return;
    if (link.hostname && link.hostname !== window.location.hostname) return;
    /* Skip add-to-cart and form buttons */
    if (link.closest('form') || link.closest('[data-hcard-add]')) return;

    e.preventDefault();
    document.body.classList.remove('hprem-enter');
    document.body.classList.add('hprem-exit');
    setTimeout(function() {
      loader.classList.remove('hprem-loader--hidden');
      setTimeout(function() { window.location.href = href; }, 150);
    }, 180);
  });
});
